import React, { useState } from 'react';
import { X } from 'lucide-react';
interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
  badge?: string;
  closeable?: boolean;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  onTabChange?: (tabId: string) => void;
  onTabClose?: (tabId: string) => void;
}
export function Tabs({
  tabs,
  defaultTab,
  onTabChange,
  onTabClose
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    onTabChange?.(tabId);
  };
  const handleTabClose = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation();
    onTabClose?.(tabId);
  };
  return <div className="flex items-center gap-1 px-3 py-2 border-b border-border-subtle bg-background-secondary" data-id="element-1835">
      {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`
            flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all
            ${activeTab === tab.id ? 'bg-background-elevated text-text-primary' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated/50'}
          `} data-id="element-1836">
          {tab.icon}
          <span data-id="element-1837">{tab.label}</span>
          {tab.badge && <span className="px-1.5 py-0.5 text-xs bg-background-primary rounded text-text-secondary" data-id="element-1838">
              {tab.badge}
            </span>}
          {tab.closeable && <button onClick={e => handleTabClose(e, tab.id)} className="ml-1 p-0.5 hover:bg-background-primary rounded transition-colors" data-id="element-1839">
              <X size={12} data-id="element-1840" />
            </button>}
        </button>)}
    </div>;
}
interface TabPanelProps {
  children: ReactNode;
}
export function TabPanel({
  children
}: TabPanelProps) {
  return <div className="flex-1 overflow-auto" data-id="element-1841">{children}</div>;
}